/**
 * @generated SignedSource<<3f5b7e38eedb67d4771124821d5c74cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsLiveArticle$data = {
  readonly flattenTypeIds: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly tmpLiveArticle: {
    readonly status: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "helpersCheckIsLiveArticle";
};
export type helpersCheckIsLiveArticle$key = {
  readonly " $data"?: helpersCheckIsLiveArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsLiveArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsLiveArticle"
};

(node as any).hash = "c6a113555a8a14a537afcd5bbc6e55b4";

export default node;
